import useDebounce from '@/composables/debounce';
import useGoalMutator from '@/composables/goal/mutate';
import useManualSort from '@/composables/sort/manual-sort';
import { dogma } from '@/api';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { useStore } from 'vuex';

export default function useGoalDetailSort(goalsSvc) {
  const store = useStore();
  const debounce = useDebounce();
  const { update } = useGoalMutator(goalsSvc, debounce, dogma, store);
  const updateChildrenSort = ({ entity, sortOperation }) => update(
    entity,
    {
      commitNowStore: true,
      commitNowDB: true,
    },
    { sortOperation },
  );
  const { listBefore, listAfter } = useManualSort(goalConfig.edges.childrenSort, updateChildrenSort);
  return { listBefore, listAfter };
}
